export class ExistingLinkedFieldSetViewModel {
    LinkedFieldSetId: string;
    ParentDisplayName: string;
    ChildDisplayName: string;
}
